// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3zHZT","footer":"Form_footer__2jwKI"};